import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface FormRowProps {
  children: ReactNode;
  className?: string;
}

export function FormRow({ children, className }: FormRowProps) {
  return (
    <div className={twMerge("flex w-full gap-3 *:flex-1", className)}>
      {children}
    </div>
  );
}
